<script setup>
import { onMounted, watch } from 'vue';
import { router, useForm } from '@inertiajs/vue3';
import ActionFilters from '@/Pages/Toolkit/Partials/ActionFilters.vue';
import SortFilters from '@/Pages/Toolkit/Partials/SortFilters.vue';
import Actions from '@/Pages/Toolkit/Partials/Actions.vue';
import JetCheckbox from '@/Jetstream/Checkbox.vue';
import JetLabel from '@/Jetstream/Label.vue';
import XLSX from 'xlsx';

// includes we need to front end locale magic
import { useI18n } from 'vue-i18n';

const props = defineProps({
        toolkit: Object,
        actions: Array,
        areas: Array,
        statuses: Array,
        themes: Array,
        sdgs: Array,
        awards: Array,
        loggedInUserId: Number,
        filters: Object,
        currentToolkitTeamUsers: Array,
        team: Object,
        auditor: Boolean,
        auditorSession: Object,
        adminAudit: Boolean,
        pastToolkit: Boolean,
        adminToolkit: Boolean,
        adminInfo: Object,
        currentActiveToolkit: Boolean,
    });


const emit = defineEmits(['statusChanged']);

const statusChanged = (action, status) => {
    emit('statusChanged', action, status);
};

let programme = null;
let organisation = null;

if(props.adminToolkit && props.adminInfo) {
    programme = props.adminInfo['programme'];
    organisation = props.adminInfo['organisation'];
} else {
    programme = router.page.props.ziggy.programme;
    organisation = router.page.props.ziggy.organisation;
}

if(!programme) {
    programme = router.page.props.programme;
}

if(!organisation) {
    organisation = router.page.props.organisation;
}

let urlNamePrefix = organisation ? "gi." : "";
if (router.page.props.auditor) {
    urlNamePrefix = 'auditor.';
}

// Get locale as set in cookie
const { locale, fallbackLocale, t} = useI18n({ useScope: 'global' });

const organisation_name = (programme.organisation_custom_name && programme.organisation_custom_name.length == 0) ? programme.organisation_custom_name : 'Organisation' ;
const team_name = (programme.organisation_custom_name && programme.team_custom_name.length == 0) ? programme.team_custom_name : 'Team' ;

    onMounted(() => {

         $('#sort-trigger').on('click', function (e) {
            e.preventDefault();
            $('#toolkit-sort-results').slideToggle();
        });

    });

    const toolkitFilters = useForm({
        filterBy: {
            area_ids: [],
            status_ids: [],
            theme_ids: [],
            sdg_ids:[],
            award_id: [],
            assigned_to_user_ids: [],
            assigned_to_me: false,
            my_starred_actions: false
        },
        orderBy: {
            order: 'lft',
            orderDirection: 'asc',
            orderClass: 'sort-icon mt-1 ml-1'
        }
    });

    // if we have filters that have been passed in props, then we want to use those values
    // to seed our toolkitFilters above
    if (props.filters && Object.keys(props.filters).length > 0) {
        toolkitFilters.filterBy = {...toolkitFilters.filterBy, ...props.filters.filterBy};
        toolkitFilters.orderBy = {...toolkitFilters.orderBy, ...props.filters.orderBy};
    }

    watch(toolkitFilters, (value) => {
        let filterURL = urlNamePrefix+'toolkit.view';
        if (props.pastToolkit) {
            filterURL = urlNamePrefix+'past-toolkit.view';
        }
        if (props.adminToolkit) {
            filterURL = 'admin-toolkit.view';
        }

        let params = {};
        if (router.page.props.auditor) {
            params = {subdomain: 'auditor', team: props.team.id};
        }
        if (props.pastToolkit) {
            params = {toolkit: props.toolkit.toolkit_id};
        }
        if (props.adminToolkit) {
            params = {type: 'admin', toolkit: props.toolkit.team_toolkit_id};
        }
        router.get(
            route(filterURL, params),
            { filter: value },
            {
                preserveState: true,
                preserveScroll: true,
                replace: true,
            }
        );
    });

    const outputOrderStatus = (order) => {

        if (toolkitFilters.orderBy.orderDirection == 'desc') {
            toolkitFilters.orderBy.orderClass = 'sort-icon mt-1 ml-1 rotate-180';
        } else {
            toolkitFilters.orderBy.orderClass = 'sort-icon mt-1 ml-1';
        }

        if (order == null) {
            return 'default';
        }

        if (order == 'reference') {
            return 'Action Reference';
        }

        if (order == 'points') {
            return 'Number of points';
        }

    }

    const filterByStarred = (e) => {
        toolkitFilters.reset();
        toolkitFilters.filterBy.my_starred_actions = e.target.checked;
    }

    function printActions() {
        window.print();
    }

    // Get toolkit and actions
    const toolkit = props.toolkit;
    const actionsData = props.actions;

    // Function to remove html from string
    function removeTags(str) {
        if ( ( str === null ) || ( str === '') )
            return false;
        else
            str = str.toString();

        // Regular expression to identify HTML tags in
        // the input string. Replacing the identified
        // HTML tag with a null string.
        return str.replace( /(<([^>]+)>)/ig, '');
    }

    function stripTags(str) {

        if (str.constructor.name == 'Object') {
            //strip tags from each item
            for (const key in str) {
                str[key] = str[key]
                .replace(/(<(br[^>]*)>)/ig, '\n')
                .replace(/(<([^>]+)>)/ig,'');
            }
            return str;
        }

        // Replace every occurrence of <br>, </div>, and </p> with a \n, and then strip the remaining tags.
        return str
                .replace(/(<(br[^>]*)>)/ig, '\n')
                .replace(/(<([^>]+)>)/ig,'');
    }

    // Set up empty array for Action JSON
    let actionsDataJSON = [];
    let commentsDataJSON = [];

    // Use reduce() method to walk through actions element by element and build up JSON object
    actionsDataJSON = actionsData.reduce((accumulator, currentAction, index, array) => {

        // Get comments for second sheet.
        const comments = currentAction.comments;
        let commentsList = '';
        for (let comment in comments){
            commentsDataJSON.push({
                'Action Reference' : currentAction.reference,
                'Comment' : comments[comment]['comment'],
                'Organisation name': organisation_name,
                'Toolkit name': toolkit.name,
                'Last updated': currentAction.updated_at
            });
           commentsList += 'Comment by: '+ comments[comment]['first_name'] + ' ' + comments[comment]['last_name']
           + '\r\n'
           + stripTags(comments[comment]['comment'])
           + '\r\n' + 'Added: ' + comments[comment]['created_at']
           + '\r\n\r\n';
        }

        // Assign name value for current action status
        function actionStatus() {
            if (typeof(currentAction.actionCurrentStatus) !== 'undefined') {
                return currentAction.actionCurrentStatus == 1 ? t('dashboard.widgets.shared.status.done')
                    : currentAction.actionCurrentStatus == 2 ? t('dashboard.widgets.shared.status.not_done')
                    : currentAction.actionCurrentStatus == 3 ? t('dashboard.widgets.shared.status.in_progress')
                    : currentAction.actionCurrentStatus == 4 ? t('dashboard.widgets.shared.status.none')
                    : 'Unassigned';
            } else {
                return 'Unassigned';
            }
        }

        function actionStarred() {
            if (typeof(currentAction.action_starred) !== 'undefined') {
                return currentAction.action_starred[0] == 1 ? 'Yes' : 'No';
            } else {
                return 'No';
            }
        }

        // Get assigned SDGs
        const SDGs = currentAction.sdgs;
        let assignedSDGsList = '';
        for (let SDG in SDGs){
            assignedSDGsList += SDGs[SDG]['name'] + ' / ';
        }
        let assignedSDGs = assignedSDGsList.slice(0, -3);

        // Get assigned Themes
        const themes = currentAction.themes;
        let assignedThemesList = '';
        for (let theme in themes){
            assignedThemesList += themes[theme]['name'] + ' / ';
        }
        let assignedThemes = assignedThemesList.slice(0, -3);

        // Get assigned Awards
        // const awards = currentAction.awards;
        // let assignedAwardsList = '';
        // for (let award in awards){
        //     if (award.constructor.name != 'Object') {
        //         award = JSON.parse(award);
        //     }
        //     assignedAwardsList += awards[award]['name'] + ' / ';
        // }
        // let assignedAwards = assignedAwardsList.slice(0, -3);

        // Get assigned award - there is only ever one assigned to an action.
        const awards = currentAction.awards;
        let assignedAward = '';
        for (let award in awards) {
            if (award.constructor.name != 'Object') {
                assignedAward = JSON.parse(awards[award]['name']);
            }
        }

        if (assignedAward[locale.value] == undefined) {
            assignedAward = assignedAward[fallbackLocale.value];
        } else {
            assignedAward = assignedAward[locale.value];
        }

        // Get list of evidence document names
        const evidence = currentAction.evidence;
        let evidenceList = '';
        for (let evidenceItem in evidence){
            evidenceList += evidence[evidenceItem]['file_name'] + ' / ';
        }
        let evidenceListItems = evidenceList.slice(0, -3);

        // Get translated action criteria
        let currentActionCriteria = '';
        if (currentAction.criteria.constructor.name != 'Object') {
            currentActionCriteria = JSON.parse(currentAction.criteria);
        } else {
            currentActionCriteria = currentAction.criteria;
        }
        if (currentActionCriteria[locale.value] == undefined) {
            currentActionCriteria = currentActionCriteria[fallbackLocale.value];
        } else {
            currentActionCriteria = currentActionCriteria[locale.value];
        }

        // Get translated action further information
        let currentActionInformation = '';
        if (currentAction.information.constructor.name != 'Object') {
            currentActionInformation = JSON.parse(currentAction.information);
        } else {
            currentActionInformation = currentAction.information;
        }
        if (currentActionInformation[locale.value] == undefined) {
            currentActionInformation = currentActionInformation[fallbackLocale.value];
        } else {
            currentActionInformation = currentActionInformation[locale.value];
        }

        // Get translated action auditor info
        let currentActionAudited = '';
        if (currentAction.audited.constructor.name != 'Object') {
            currentActionAudited = JSON.parse(currentAction.audited);
        } else {
            currentActionAudited = currentAction.audited;
        }
        if (currentActionAudited[locale.value] == undefined) {
            currentActionAudited = currentActionAudited[fallbackLocale.value];
        } else {
            currentActionAudited = currentActionAudited[locale.value];
        }

        accumulator.push({
            'Last updated': currentAction.updated_at,
            'Organisation name': organisation_name,
            'Toolkit name': toolkit.name,
            'Action Reference' : currentAction.reference,
            'Action Criteria' : stripTags(currentActionCriteria),
            'Further information' : stripTags(currentActionInformation),
            'How you will be audited' : stripTags(currentActionAudited),
            'Current status' : actionStatus(),
            'Action Starred': actionStarred(),
            'SDGs' : assignedSDGs,
            'Themes' : assignedThemes,
            'Assigned Award' : assignedAward,
            'Evidence Uploaded' : evidenceListItems,
            'Points' : currentAction.points,
            'Comments' : commentsList
        });
        return accumulator;
    },[]);

    function reloadPageAndExport() {
        sessionStorage.setItem("reloading", "true");
        document.location.reload();
    }

    window.onload = function() {
    var reloading = sessionStorage.getItem("reloading");
        if (reloading) {
            sessionStorage.removeItem("reloading");
            downloadFile();
        }
    }


    // Function to generate XLSX spreadsheet using JSON object
    function downloadFile() {
            //your code here
            const datePrefix = new Date().valueOf();
            let excelActionsData = XLSX.utils.json_to_sheet(actionsDataJSON)
            //let excelCommentsData = XLSX.utils.json_to_sheet(commentsDataJSON)
            const wb = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(wb, excelActionsData, 'Actions data')
            //XLSX.utils.book_append_sheet(wb, excelCommentsData, 'Action Comments data')
            XLSX.writeFile(wb,'actions_export_' + datePrefix + '.xlsx')
    }
</script>

<template>
    <div class="">
        <form @submit.prevent="submit" id="toolkit-action-filters" class="">

            <div id="filter-toggles-wrapper" class="flex justify-between ">
                <h2 class="text-base">Filters</h2>
                <div id="filter-toggles" class="flex">
                    <!-- <div class="flex items-center form-control">
                        <JetCheckbox id="actions-assigned-to-me" name="actions-assigned-to-me" class="mr-3 toolkit-checkbox" />
                        <JetLabel for="actions-assigned-to-me" value="Assigned to me" class="" />
                    </div> -->
                    <div class="flex items-center pl-3 form-control" v-if="!auditor">
                        <JetCheckbox id="actions-starred" name="actions-starred" class="mr-3 toolkit-checkbox" v-on:click="filterByStarred($event)" />
                        <JetLabel for="actions-starred" :value="$t('toolkit.filters.starred')" class="" />
                    </div>
                </div>
            </div>

            <div class="flex flex-wrap form-control-group">
                <ActionFilters :areas="areas" :statuses="statuses" :themes="themes" :sdgs="sdgs" :awards="awards" :filters="filters" :toolkitFilters="toolkitFilters" :currentToolkitTeamUsers="currentToolkitTeamUsers" :team="team" />
            </div>

        </form>


        <div id="toolkit-filter-notifications" class="flex justify-between pt-5">
            <div class="filter-notification">
                <p class="font-bold">
                    <!-- Seeing {{actions.length}} results based on Theme: Embedding & Communication, Assigned to me -->
                    {{ $t('toolkit.filters.count', { length: actions.length }) }}
                </p>
            </div>

            <div class="flex items-center justify-between">

                <button id="sort-trigger" class="flex mr-3 align-middle">
                    <span class="sort-label">{{ $t('toolkit.sort.sort') }}: <span class="current-sort">{{outputOrderStatus(toolkitFilters.orderBy.order)}}</span></span>
                    <svg v-bind:class="toolkitFilters.orderBy.orderClass" width="16" height="14" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.90627 2.26857H11.2813C11.4387 2.26857 11.5898 2.20882 11.7011 2.10246C11.8125 1.9961 11.875 1.85184 11.875 1.70143V0.567143C11.875 0.416727 11.8125 0.272472 11.7011 0.166112C11.5898 0.0597524 11.4387 0 11.2813 0H8.90627C8.74879 0 8.59777 0.0597524 8.48642 0.166112C8.37507 0.272472 8.31252 0.416727 8.31252 0.567143V1.70143C8.31252 1.85184 8.37507 1.9961 8.48642 2.10246C8.59777 2.20882 8.74879 2.26857 8.90627 2.26857ZM8.90627 6.80571H13.6563C13.8137 6.80571 13.9648 6.74596 14.0761 6.6396C14.1875 6.53324 14.25 6.38899 14.25 6.23857V5.10429C14.25 4.95387 14.1875 4.80962 14.0761 4.70326C13.9648 4.5969 13.8137 4.53714 13.6563 4.53714H8.90627C8.74879 4.53714 8.59777 4.5969 8.48642 4.70326C8.37507 4.80962 8.31252 4.95387 8.31252 5.10429V6.23857C8.31252 6.38899 8.37507 6.53324 8.48642 6.6396C8.59777 6.74596 8.74879 6.80571 8.90627 6.80571ZM18.4062 13.6114H8.90627C8.74879 13.6114 8.59777 13.6712 8.48642 13.7775C8.37507 13.8839 8.31252 14.0282 8.31252 14.1786V15.3129C8.31252 15.4633 8.37507 15.6075 8.48642 15.7139C8.59777 15.8202 8.74879 15.88 8.90627 15.88H18.4062C18.5637 15.88 18.7147 15.8202 18.8261 15.7139C18.9374 15.6075 19 15.4633 19 15.3129V14.1786C19 14.0282 18.9374 13.8839 18.8261 13.7775C18.7147 13.6712 18.5637 13.6114 18.4062 13.6114ZM8.90627 11.3429H16.0313C16.1887 11.3429 16.3397 11.2831 16.4511 11.1767C16.5624 11.0704 16.625 10.9261 16.625 10.7757V9.64143C16.625 9.49101 16.5624 9.34676 16.4511 9.2404C16.3397 9.13404 16.1887 9.07429 16.0313 9.07429H8.90627C8.74879 9.07429 8.59777 9.13404 8.48642 9.2404C8.37507 9.34676 8.31252 9.49101 8.31252 9.64143V10.7757C8.31252 10.9261 8.37507 11.0704 8.48642 11.1767C8.59777 11.2831 8.74879 11.3429 8.90627 11.3429ZM6.53127 11.3429H4.75002V0.567143C4.75002 0.416727 4.68747 0.272472 4.57612 0.166112C4.46477 0.0597524 4.31374 0 4.15627 0H2.96877C2.8113 0 2.66028 0.0597524 2.54893 0.166112C2.43758 0.272472 2.37503 0.416727 2.37503 0.567143V11.3429H0.593778C0.0671965 11.3429 -0.199248 11.954 0.174814 12.3109L3.14356 15.7138C3.2549 15.82 3.40586 15.8797 3.56327 15.8797C3.72067 15.8797 3.87163 15.82 3.98297 15.7138L6.95172 12.3109C7.32355 11.9547 7.05896 11.3429 6.53127 11.3429Z" fill="black" transform="" />
                    </svg>
                </button>

                <button @click="reloadPageAndExport()" class="flex mr-2" :title="$t('toolkit.export.title')">
                    <span class="sr-only">{{ $t('toolkit.export.title') }}</span>
                    <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 48 48" width="48px" height="48px">
                        <path fill="#4CAF50" d="M41,10H25v28h16c0.553,0,1-0.447,1-1V11C42,10.447,41.553,10,41,10z"/>
                        <path fill="#FFF" d="M32 15H39V18H32zM32 25H39V28H32zM32 30H39V33H32zM32 20H39V23H32zM25 15H30V18H25zM25 25H30V28H25zM25 30H30V33H25zM25 20H30V23H25z"/>
                        <path fill="#2E7D32" d="M27 42L6 38 6 10 27 6z"/>
                        <path fill="#FFF" d="M19.129,31l-2.411-4.561c-0.092-0.171-0.186-0.483-0.284-0.938h-0.037c-0.046,0.215-0.154,0.541-0.324,0.979L13.652,31H9.895l4.462-7.001L10.274,17h3.837l2.001,4.196c0.156,0.331,0.296,0.725,0.42,1.179h0.04c0.078-0.271,0.224-0.68,0.439-1.22L19.237,17h3.515l-4.199,6.939l4.316,7.059h-3.74V31z"/>
                    </svg>
                </button>

                <button @click="printActions()" id="toolkit-print-actions" :aria-label="$t('toolkit.export.print')">
                    <span class="material-icons-outlined">print</span>
                </button>
            </div>

        </div>

        <form @submit.prevent="submit" id="toolkit-sort-results" class="flex justify-between pt-5">
            <div id="sort-options-dropdown" class="flex flex-wrap justify-between w-full pb-2 align-middle form-control-group">
                <SortFilters :toolkitFilters="toolkitFilters" />
            </div>
        </form>

        <div id="actions-results" class="mt-10 pb-[150px]" aria-live="polite">
            <Actions :toolkit="toolkit" :team="team" :currentToolkitTeamUsers="currentToolkitTeamUsers" :actions="actions" :filters="filters" :loggedInUserId="loggedInUserId" :auditor="auditor" :auditorSession="auditorSession" :adminAudit="adminAudit" :pastToolkit="pastToolkit" :adminToolkit="adminToolkit" :adminInfo="adminInfo" :currentActiveToolkit="currentActiveToolkit" @statusChanged="statusChanged"/>
        </div>

    </div>

</template>
